import { useCallback, useSyncExternalStore } from 'react';

/** Whether the media query matches; `false` where `matchMedia` is missing (tests). */
export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (onChange: () => void) => {
      if (typeof window === 'undefined' || !window.matchMedia) return () => {};
      const media = window.matchMedia(query);
      media.addEventListener('change', onChange);
      return () => media.removeEventListener('change', onChange);
    },
    [query],
  );
  const snapshot = () =>
    typeof window !== 'undefined' && !!window.matchMedia && window.matchMedia(query).matches;
  return useSyncExternalStore(subscribe, snapshot, () => false);
}

/** Phones: lists instead of tables, sheets instead of dialogs. */
export const compactQuery = '(max-width: 767px)';

/** Phones in portrait: compact page header and list toolbar (#60). */
export const phoneQuery = '(max-width: 639px)';

/** Phones and tablets: tab bar and top bar instead of the sidebar. */
export const tabbarQuery = '(max-width: 1023px)';
